import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import Reveal from "@/components/site/Reveal";

const items = [
  {
    q: "Je ne connais pas cette approche, est-ce un problème ?",
    a: "Non. L'atelier commence par une présentation du cadre, de la posture attendue et des étapes du travail. Aucune préparation théorique n'est nécessaire.",
  },
  {
    q: "Je ne veux pas parler devant un groupe.",
    a: "C'est entendu. Vous pouvez tout à fait participer comme représentant : vous prenez place dans le travail des autres sans exposer votre propre situation. La parole reste un choix, jamais une obligation.",
  },
  {
    q: "Est-ce que c'est pour moi ?",
    a: "Si vous ressentez des blocages répétitifs, des dynamiques relationnelles difficiles à comprendre ou l'impression que quelque chose se rejoue, cette approche peut être pertinente. En cas de doute, vous pouvez me contacter avant l'inscription.",
  },
  {
    q: "Quelle est la confidentialité du cadre ?",
    a: "Le groupe s'engage à la confidentialité de ce qui se dit et de ce qui se vit pendant la journée. Le cadre est posé clairement en début de séance.",
  },
  {
    q: "Que se passe-t-il après l'atelier ?",
    a: "Un temps d'intégration est prévu en fin de journée. Pour celles et ceux qui le souhaitent, un suivi individuel peut être envisagé pour poursuivre le travail.",
  },
];

export default function Objections() {
  return (
    <section
      data-testid="ateliers-objections"
      className="py-24 md:py-32 bg-[#FAF7F8]"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="text-center">
            <span className="text-sm uppercase tracking-[0.2em] text-[#C98FA3] font-medium">
              — Vos questions
            </span>
            <h2 className="font-serif-display text-4xl md:text-5xl font-light mt-4 leading-[1.05]">
              Questions fréquentes
            </h2>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-14 space-y-3">
            {items.map((it, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`ateliers-faq-item-${i}`}
                className="bg-white rounded-2xl border border-[#DDD7E2] px-6 data-[state=open]:border-[#C98FA3] transition-colors"
              >
                <AccordionTrigger className="text-left font-serif-display text-lg md:text-xl py-6 hover:no-underline text-[#1E1E2A]">
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="text-base text-[#5F6170] leading-relaxed pb-6">
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
